import React from "react";

const MARK = "\u0000";

// A translated sentence with one {variable} rendered as an element (a bold
// name, a highlighted reward) instead of plain text, wherever the language
// puts it in the sentence.
export function tSlot(
  t: (key: never, vars?: Record<string, string>) => string,
  key: string,
  slot: string,
  node: React.ReactNode,
) {
  const [before, after = ""] = t(key as never, { [slot]: MARK }).split(MARK);
  return (
    <>
      {before}
      {node}
      {after}
    </>
  );
}
